export const arrayContainsOnlyIntegers = (values: number[]): boolean => {
  return values.length > 0 && values.every(n => Number.isInteger(n));
};

export const arrayContainsOnlyPositiveNumbers = (values: number[]): boolean => {
  return (
    values.length > 0 && values.every(n => typeof n === "number" && n >= 0)
  );
};

export const arrayContainsDuplicates = <T>(values: T[]): boolean => {
  return values.length !== new Set<T>(values).size;
};

export const isObject = (value: any): boolean =>
  value !== null && typeof value === "object";

export const isEmptyObject = (value: any): boolean =>
  Object.keys(value).length === 0 && value.constructor === Object;
